{
    "back": "Vissza",
    "cancel": "Mégse",
    "delete": "Törlés",
    "done": "Kész",
    "error_occurred": "Hiba lépett fel",
    "expired": "Lejárt",
    "field_error_any": "Kérjük, adjon meg legalább egyet a következő mezők közül: ${1}",
    "field_error_date_invalid": "Kérjük, adjon meg egy érvényes dátumot",
    "field_error_date_max": "A dátum ${1} vagy annál korábbi kell legyen",
    "field_error_date_min": "A dátum ${1} vagy annál későbbi kell legyen",
    "field_error_email": "Kérjük, adjon meg egy érvényes e-mail címet",
    "field_error_length_max": "Ez a mező legfeljebb ${1} karakter hosszú lehet",
    "field_error_length_min": "Kérjük, adjon meg legalább ${1} karaktert",
    "field_error_max": "A maximális érték ${1}",
    "field_error_min": "A minimális érték ${1}",
    "field_error_phone_invalid": "Kérjük, adjon meg egy érvényes telefonszámot",
    "field_error_phone_starts_with_zero": "Egy országkód már létezik. Kérjük, távolítsa el a \"0\"-t a telefonszámból.",
    "field_error_required": "Kérjük, töltse ki ezt a mezőt",
    "field_is_required": "Ez a mező kötelező",
    "field_placeholder_address_search": "Adjon meg egy helyet",
    "field_select_not_found": "${1} nem található",
    "network_error": "Hálózati hiba",
    "no_results": "Nincs eredmény",
    "ok": "OK",
    "open": "Megnyitás",
    "page_not_found_description": "Az oldal, amelyet megpróbált kérelmezni, nem létezik. Lehet, hogy hibásan írta be az URL-t.",
    "page_not_found_link": "Vissza a főoldalra.",
    "page_not_found_title": "Az oldal nem található",
    "save": "Mentés",
    "state_refused": "Elutasította"
}